export default __webpack_public_path__ + "static/media/white-woman-meditation.132931f3.jpg";